// @flow
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
/* eslint-disable-next-line import/order */ // Prioritize loading polyfills.
import '@ungap/global-this'

import Bugsnag from '@bugsnag/js'
import { type GatsbyBrowser, navigate } from 'gatsby'
import * as React from 'react'
import ReactDOM from 'react-dom'

import { callback, session } from '@toggl/auth'
import { tracer } from '@toggl/bugsnag'

import { pricingPlanUrls } from './data/track/signup'
import { Provider } from './src/components/Provider'

declare var process: WebProcess
declare var document: Document
type $GatsbyBrowser<API: string> = $ElementType<GatsbyBrowser, API>

export const wrapRootElement: $GatsbyBrowser<'wrapRootElement'> = ({
  element,
}) => <Provider>{element}</Provider>

window.__tracer = Bugsnag.getPlugin(tracer.name).tracer

export const onClientEntry: $GatsbyBrowser<'onClientEntry'> = () => {
  if (session.check() && window.heap) {
    window.heap.identify(session.getUserId() ?? '')
  }

  callback.redirectLegacyAuthCallbacks()
}

export const onInitialClientRender: $GatsbyBrowser<'onInitialClientRender'> = () => {
  callback.handleAuthErrors(navigate, pricingPlanUrls)
}

export const replaceHydrateFunction: $GatsbyBrowser<'replaceHydrateFunction'> = () => (
  element,
  container,
  callback
) => {
  // Experimental React, misisng flow props
  // $FlowFixMe[prop-missing]
  ReactDOM.createRoot(container, {
    hydrate: true,
    // FIXME: This is what people on the interwebs do with Gatsby and suspense, but it's not working.
    //        Try again if we upgrade past react-dom@0.0.0-experimental-5027eb465.
    // hydrationOptions: { onHydrated: callback },
  }).render(element)

  if (callback) {
    callback()
  }
}
